import React from "react";

interface IUploadProps {
  className?: string;
}

const Upload = ({ className }: IUploadProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 147.21 99.268"
  >
    <path
      id="Path_64"
      data-name="Path 64"
      d="M13.37,31.336H3.54A6.629,6.629,0,0,1,1.985,31.3C1.294,31.132.3,30.97.068,30.494s.163-1.44.563-1.984q3.7-5.021,7.541-9.94C12.461,13.05,16.793,7.564,21.1,2.054c2.156-2.758,3.461-2.723,5.713.011,7.054,8.562,14.155,17.085,21.207,25.648a10.478,10.478,0,0,1,1.05,2.079,9.6,9.6,0,0,1-2.368.682c-3.179.079-6.365.109-9.543,0-1.583-.055-2.064.433-2.055,2.039.063,11.743.033,23.487.033,35.23,0,2.711-.369,3.132-3.069,3.147q-7.983.045-15.966,0c-2.166-.011-2.654-.536-2.656-2.68q-.009-17.7-.008-35.4C13.434,32.4,13.4,32,13.37,31.336Z"
      transform="translate(98.27 70.911) rotate(180)"
      fill="#707070"
    />
    <path
      id="Path_65"
      data-name="Path 65"
      d="M75.489,195.092c3.061,0,5.664,0,8.268,0,1.342,0,1.062,1.025,1.065,1.8.018,6.386.032,12.772.008,19.158A25.359,25.359,0,0,0,88.1,229.261c5.063,8.628,12.626,13.186,22.647,13.216,25.672.075,51.344,0,77.018.026A25.384,25.384,0,0,0,212,225.284a34.721,34.721,0,0,0,1.46-9.579c.222-6.187.109-12.387.035-18.582-.019-1.568.429-2.156,2.048-2.07,2.281.123,4.574.032,7.052.032.038.8.091,1.422.091,2.038.007,6.258.026,12.517,0,18.775-.047,11.094-4.128,20.42-12.586,27.628a34.24,34.24,0,0,1-22.773,8.145c-25.417.051-50.835.186-76.25-.044-15.052-.137-25.974-7.357-32.421-20.988a23.915,23.915,0,0,1-2.445-8.6C75.718,213.194,75.7,204.323,75.489,195.092Z"
      transform="translate(-75.489 -152.49)"
      fill="#707070"
    />
  </svg>
);

export default Upload;
